import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle, astriskStyle } from 'src/styles/CommonStyles.styled';

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: ${({ spaceBetween }) =>
        spaceBetween ? spaceBetween : 'space-between'};
    align-items: center;
    padding: ${({ padding }) => (padding ? padding : '1rem')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
`;

export const Header = styled.div`
    color: #140f4b;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '15px')};
    letter-spacing: ${(props) =>
        props.letterSpacing ? props.letterSpacing : '0px'};
    font-family: 'AvenirNextWorld Demi';
    padding: ${(props) => (props.padding ? props.padding : '0')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    word-break: ${(props) => props.wordBreak};
    ${media.mobileDevice`
        padding: ${({ mobilePadding }) => (mobilePadding ? mobilePadding : 0)};
    `}
    ${astriskStyle};
`;

export const BasicOptionContainer = styled.div`
    display: flex;
    padding: ${({ padding }) => (padding ? padding : '16px 0px')};
    ${media.mobileDevice`
        // justify-content: space-between;
        width:${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
    `}
`;

export const ContentBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: ${({ contentHeight }) =>
        contentHeight ? contentHeight : 'calc(100% - 65px)'};
    position: relative;
    ${media.mobileDevice`
        //height: calc(100% - 135px);
    `}

    .procedure-detail-wrapper {
        ${media.mobileDevice`
            padding-bottom: 110px;
        `}
    }
`;

export const Options = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    gap: 10px;
    margin: 16px 0;

    ${media.mobileDevice`
        grid-template-columns: repeat(1, 1fr);
    `}
`;

export const Add = styled.div`
    color: #1010eb;
    font-family: AvenirNextWorld Demi;
    font-size: 16px;
    margin: 0 10px;

    ${media.mobileDevice`
        margin: 10px;
    `}
`;

export const AddRecipientContainer = styled.div`
    display: flex;
    align-items: ${({ alignItems }) => (alignItems ? alignItems : 'center')};
    padding: 5px 0;
    flex-direction: ${({ flexDirection }) => flexDirection};
    ${media.mobileDevice`
        flex-direction : column;
        justify-content: flex-start;
        align-items: flex-start;
    `}
`;

export const InputCont = styled.div`
    width: 40%;

    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const CheckBoxContainer = styled.div`
    word-break: break-all;
`;

export const InputWithRecipientContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    ${media.mobileDevice`
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
`}
`;

export const ErrorContainer = styled.span`
    color: #e71717;
    font-size: 12px;
`;
export const HistoryContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
export const Row = styled.div`
    display: flex;
    padding: ${({ padding }) => (padding ? padding : '15px 0px')};
`;
export const Icon = styled.img`
    width: 24px;
    height: 24px;
    margin: 0px;
`;
export const Status = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 16px;
`;
export const DemiText = styled.div`
    font-size: 14px;
    font-family: AvenirNextWorld Demi;
    word-break: ${({ wordBreak }) => wordBreak};
`;
export const RegularSmallText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: AvenirNextWorld Regular;
    letter-spacing: -0.1px;
`;

export const BackButton = styled.div`
    /* margin: 5px 20px; */
    color: #1010eb;
    font-family: AvenirNextWorld Regular;
    font-size: 16px;
    padding: 0 1rem;
`;

export const DetailBody = styled.div`
    ${scrollBarStyle}
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90%;
    padding: ${({ detailBodyPadding }) =>
        detailBodyPadding ? detailBodyPadding : '0rem 1rem 1rem 1rem'};
    overflow-y: scroll;
    overflow-x: ${({ overflowX }) => overflowX};
    position: relative;
    flex-grow: 1;
    .react-pdf__Document,
    .react-pdf__Page__canvas {
        width: 100% !important;
        height: auto !important;
    }
    .pdfMainContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 1px 4px #bdbdbd;
        margin: 16px;
        height: ${({ pdfContainerHeight }) => pdfContainerHeight};
        flex-direction: column;
    }
    .pdfLoader {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
export const FooterContent = styled.div`
    ${media.mobileDevice`
        display:none;
    `}
`;
export const ButtonContainer = styled.div`
    display: none;
    ${media.mobileDevice`
        display:flex;
        width:100%;
        margin:10px 0px 15px 0;
        height: ${({ height }) => height};
        border-top: ${({ borderTop }) => borderTop};
        justify-content: ${({ justifyContent }) => justifyContent};
    `}
`;

export const StyledHorizontalRow = styled.hr`
    width: 100%;
    opacity: 0.3;
    color: #707070;
    ${media.mobileDevice`
        display:none;
    `}
`;
export const UploadedFilesContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    ${media.mobileDevice`
       flex-direction:column;
    `}
`;
export const FileLinkDiv = styled.div`
    cursor: pointer;
    flex: auto;
    word-break: break-word;
`;
export const FileLinkContainer = styled.div`
    display: flex;
`;
export const FileImage = styled.img.attrs((props) => ({
    src: props.imgPath,
}))`
    height: 25px;
    width: 25px;
    margin-right: 5px;
    cursor: pointer;
`;
